<template>
  <iframe
    :id="iframeId"
    :src="iframeSrc"
    frameborder="0"
    style="border: none; width: 100%"
    title="Salesmanago Newsletter"
  ></iframe>
</template>

<script setup lang="ts">
  import { getErrorMessage } from '~/utils/errors'

  const { locale } = useI18n()

  // IDs por idioma
  const iframeIds = {
    es: 'smIframe-42xaalgquf9kv9ti',
    en: 'smIframe-g5sm3a5x9n9rtu39',
    de: 'smIframe-8vwzdzp4e58lqnwb',
    fr: 'smIframe-c72bx5enywqsqprk',
    it: 'smIframe-48qbm6tuj2gma57r'
  }

  const iframeId = computed(() => iframeIds[locale.value] || iframeIds.es)
  const iframeSrc = computed(() => `https://salesmanago.com/ms/sid/3b2930f9080c4bf5/${iframeId.value.replace('smIframe-', '')}.htm`)

  const iframe = ref<HTMLIFrameElement | null>(null)

  onMounted(() => {
    const PREFIX_OUTGOING = 'SM_RESIZE_IFRAME:' + iframeId.value
    const PREFIX_INCOMING = 'SM_IFRAME_HEIGHT:' + iframeId.value + ':'

    const findIframe = (): HTMLIFrameElement | null => {
      if (iframe.value) return iframe.value
      const el = document.getElementById(iframeId.value)
      iframe.value = el instanceof HTMLIFrameElement ? el : null
      return iframe.value
    }

    window.addEventListener('resize', () => {
      const i = findIframe()
      if (i?.contentWindow) {
        i.contentWindow.postMessage(PREFIX_OUTGOING, '*')
      }
    })

    window.addEventListener('message', (event) => {
      const messageData = event.data
      try {
        if (typeof messageData !== 'string' || !messageData.startsWith(PREFIX_INCOMING)) return
        const i = findIframe()
        if (i) i.style.height = parseInt(messageData.replace(PREFIX_INCOMING, '')) + 'px'
      } catch (e: unknown) {
        console.error('Error adjusting iframe height:', getErrorMessage(e))
      }
    })
  })

</script>